import { SelectionEventType } from "./SelectionEventType";
export class SelectionEvent {
    constructor(public type: SelectionEventType, public id: any) {
    }
}
